import styles from './BeneficaryPage.module.scss';
import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import LoadingIndicator from '../components/loading-indicator/LoadingIndicator';
import MainNav from '../components/main-nav/MainNav';
import { ProfileBar } from '../components/profile-bar/ProfileBar';
import { Beneficiary } from '../transfer-page/components/beneficiary/Beneficiary';
import AddBeneficary from 'views/common/add-beneficary/Add-Beneficary';
import { commonActions } from '../../stores/_actions';
function BeneficaryPage() {
  let status;
  const dispatch = useDispatch();
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  useSelector((state) => {
    status = state.beneficary?.beneficiaryList;
  });
  useEffect(() => {
    dispatch(commonActions.getCustDetailsByCode(payload));
  }, []);
  const [payload, setPayload] = useState({
    Id: null,
    Message: null,
    CustomerCode: null,
    Status: false,
    SessionID: sessionId,
    IdType: null,
    langcode: '0001',
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
  });
  let userProfile = useSelector((state) => state.getCustDetails.data);
  return (
    <LoadingIndicator>
      <div className={styles.mainContainer}>
        <MainNav />
        <div className={styles.mainContainer__contentPart}>
          <ProfileBar profile={userProfile} />
          <div className={styles.mainContainer__pageCont}>
            <div className={styles.pageLeft}>
              <Beneficiary />
            </div>
            <AddBeneficary />
          </div>
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { BeneficaryPage };
